import { useUserInfo } from 'hooks/userInfoHook';
import { useQuerySavedMemberCard } from 'pages/company-profile/components/tabs/billing/queries';
import { useCheckCreditCardPermission } from 'hooks/useCheckCreditCardPermission';

const useCheckNeedToAddCreditCard = () => {
  const { userInfo } = useUserInfo();
  const memberId = userInfo?.companyId;

  const { canViewSavedCard } = useCheckCreditCardPermission();

  const { data: savedMemberCardsData, isLoading } = useQuerySavedMemberCard({
    memberId,
    staleTime: 0,
  });

  const memberCardData = savedMemberCardsData?.memberSaveCards?.[0];
  const hasSavedMemberCard = Boolean(memberCardData?.memberPaymentProfileId);

  return {
    isLoading,
    isNeedAddCreditCard: canViewSavedCard
      ? !hasSavedMemberCard && !isLoading
      : false,
  };
};

export { useCheckNeedToAddCreditCard };
